export const ymPushEvent = (key = '', payload = {}) => {
  if (window.ym) {
    window.ym(26001372, 'reachGoal', key, payload);
  }
};

export const ymPushParams = (payload = {}) => {
  if (window.ym) {
    window.ym(26001372, 'params', payload);
  }
};

export const PAGE_CATEGORY = 'page_category';
export const PERSONAL_ACCOUNT = 'personal_account';

export const pushAnalytics = (data) => {
  ymPushParams({
    [PAGE_CATEGORY]: {
      [PERSONAL_ACCOUNT]: data,
    },
  });
};
